import { LogOut, setUserEntry, loginToken } from "../server/Customer";

// Guest credentials used to re-acquire a token after logout (mirrors App's haveGetToken).
export const GUEST_CREDS = {
  userName: "guest",
  password: "a1234567",
  grant_type: "password",
};

export const loginAsGuest = (dispatch) =>
  dispatch(loginToken(GUEST_CREDS, false));

// Shared logout flow: clear session, open the login entry, go home, re-login as guest.
export const logout = ({ dispatch, navigate }) => {
  dispatch(LogOut());
  dispatch(setUserEntry([true, "login"]));
  navigate("/");
  return loginAsGuest(dispatch);
};
